import order from '@apis/order'
import { outlinestore, totalusers } from '@assets/icons'
import Analytic from '@commons/cards/analytic'
import Column from '@components/column'
import Grid from '@components/grid'
import Status from '@components/status'
import Table from '@components/table'
import Title from '@components/title'
import { RootState } from '@store/index'
import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import styled from '@emotion/styled'
import theme from '@utils/theme'
import OrderList from './lists'
import DashboardCard from '@commons/cards/dashboard'
import { cardConfig } from '../constant'

const Order = () => {
  const navigate = useNavigate()

  return (
    <Fragment>
      <Column>
        <DashboardCard cardConfig={cardConfig} />
        <Title
          textone="Store Management >"
          texttwo="Orders"
          hasButton
          btnText="Create Product"
          onButtonClick={() =>
            navigate('/admin/store-management/product/create-product')
          }
        />
        <OrderList />
      </Column>
    </Fragment>
  )
}

export default Order

// Styled Components
